module.exports = __webpack_public_path__ + "static/img/集团公众号.3f44f2c8.png";